import React, { useEffect, useState } from 'react';
import Navigation from '../../Components/Navigation/Navigation';
import Heading from '../../Components/Heading/Heading';
import Footer from '../../Components/Footer/Footer';
import BlogCard from './BlogCard';
import './Blogs.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ReactGA from 'react-ga';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useGetBlogDataQuery, useGetCategoriesQuery } from '../../Api/blogApi';

const Blogs = () => {
  // All hooks at the top
  const [search, setSearch] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const { data: blogData, isLoading, isError } = useGetBlogDataQuery();
  const [blogs, setBlogs] = useState([]);
  const { data: categoriesData, isLoading: isCategoriesLoading, isError: isCategoriesError } = useGetCategoriesQuery();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const blogs = Array.isArray(blogData) && blogData.length > 0 
      ? blogData
      : [];
    setBlogs(blogs);
  }, [blogData]);

  useEffect(() => {
    if (categoriesData && Array.isArray(categoriesData)) {
      setCategories(categoriesData);
    }
  }, [categoriesData]);

  useEffect(() => {
    AOS.init({
      duration: 3000,
    });
  }, []);

  useEffect(() => {
    ReactGA.pageview(window.location.pathname);
  }, []);

  // Loading and error handling (after all hooks)
  if (isLoading || isCategoriesLoading) {
    return <div style={{textAlign: 'center', marginTop: 40}}>Loading blogs and categories...</div>;
  }
  if (isError || isCategoriesError) {
    return <div style={{color: 'red', textAlign: 'center', marginTop: 40}}>Failed to load blogs or categories. Please try again later.</div>;
  }

  return (
    <>
      <Navigation offer={true} />
      <Heading Title="Our Blogs" MiniTitle="" Links="Our Blogs"/>
      <div className="blogs-page">
        <h2 className="blogs-page__mission">
          Our Mission Is To Make Knowledge And News Accessible For Everyone
        </h2>
        <div className="blogs-page__searchbar">
          <input
            type="text"
            placeholder="Search Smarter, Innovate Faster"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          <span className="blogs-page__searchicon">🔍</span>
        </div>
        <div className="blogs-page__categories" >
          <Slider
            slidesToShow={
              window.innerWidth > 1300 ? 5 : window.innerWidth > 900 ? 3 : 2
            }
            slidesToScroll={1}
            infinite={false}
            arrows={true}
            responsive={[
              {
                breakpoint: 1300,
                settings: { slidesToShow: 3 }
              },
              {
                breakpoint: 900,
                settings: { slidesToShow: 2 }
              },
              {
                breakpoint: 600,
                settings: { slidesToShow: 1 }
              }
            ]}
          >
            {categories.map(cat => (
              <button
                key={cat.id}
                className={`blogs-page__category${selectedCategory === cat ? " active" : ""}`}
                onClick={() => setSelectedCategory(cat?.name === selectedCategory ? "" : cat?.name)}
              >
                <span className="blogs-page__cat-icon">🟩</span>
                {cat?.name}
              </button>
            ))}
          </Slider>
        </div>
        <div className="blogs-page__cards">
          {blogs.map(blog => (
            <BlogCard blog={blog} key={blog.id} categories={categories} />
          ))}
        </div>
      </div>
      <Footer/>
    </>
  );
};

export default Blogs;
